function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.quantityUpdateUnsubscriber = undefined;
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    // if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
    if (event instanceof KeyboardEvent) {
      if (elementToFocus !== undefined && elementToFocus !== null) {
        elementToFocus.setAttribute('aria-expanded', false);
      }
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      try{
        if (modal) modal.show(button);
      }catch(ex){
        console.log(ex);
      }
      
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            console.log("1",this.prevButton)
      //this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      console.log("2",this.sliderItemsToShow.length)
      //this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.hideOtherImg();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  hideOtherImg(){
    $('.thumbnail-list__item').removeClass('hide-imgs');
    let currentId = this.currentVariant.option1;
    $('.thumbnail-list__item').each(function(){
      let dataValue = $(this).data("varinet-id");
      if(currentId != dataValue){
        $(this).addClass("hide-imgs");
      }
      if(dataValue.indexOf(".mp4") !== -1 ){
        $(this).removeClass("hide-imgs");
      }
      if (dataValue.toLowerCase().indexOf("common") !== -1) {
          $(this).removeClass("hide-imgs");
        }
      
    })
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

$(document).ready(function(){ 
  $(window).scroll(function(){ 
      if ($(this).scrollTop() > 100) { 
          $('#scroll').fadeIn(); 
      } else { 
          $('#scroll').fadeOut(); 
      } 
  }); 
  $('#scroll').click(function(){ 
      $("html, body").animate({ scrollTop: 0 }, 600); 
      return false; 
  });
});

// ADA fixes

$(document).ready(function () {
  $(".Customer__page-heading").on("keydown", function (event) {
    if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) {
      event.preventDefault();

   
      var pageTitle = $(this).attr("data-page-title");

      if (pageTitle) {
      
        $(".CustomerNav__link[data-page-title='" + pageTitle + "']").focus();
      }
    }
  });
});


let enterKeyPressed = false;

$(document).ready(function () {
    $("#end-h4-1, #end-h4-2, #end-h4-3, #end-h4-4, #end-h4-5, #end-h4-6, #end-h4-7, #end-h4-8, #end-h4-9").on("keydown", function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            enterKeyPressed = true;


            setTimeout(() => {
                enterKeyPressed = false;

            }, 1000); 
        }
    });

    $("#end-h4-1, #end-h4-2, #end-h4-3, #end-h4-4, #end-h4-5, #end-h4-6, #end-h4-7, #end-h4-8, #end-h4-9").on("keydown", function (event) {
        if ((event.key === "Tab" || event.keyCode === 9) && !event.shiftKey && !enterKeyPressed) {
            event.preventDefault();
            var nextLevel = $(this).attr("data-next-level");
            if (nextLevel) {
                $("#" + nextLevel).focus();
            }
        }
    });

  /*  $(".end-p").on("keydown", function (event) {
        if ((event.key === "Tab" || event.keyCode === 9) && !event.shiftKey) {
            event.preventDefault();
            var nextLevel = $(this).attr("data-next-level");
            if (nextLevel) {
                $("#" + nextLevel).focus();
            }
        }
    });*/
});

$(document).ready(function () {
  $(".CustomerNav__link").on("keydown", function (event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      event.preventDefault();

      var nextLevel = $(this).attr("data-next-level");

      if (nextLevel) {
        var h2Element = $("#" + nextLevel);
        if (h2Element.length) {
          $(".Customer__page.js-page").css("display", "none");
          h2Element.closest(".Customer__page.js-page").css("display", "block");
        }
        $("#" + nextLevel).focus();
      }
    }
  });
});

$(document).ready(function () {
  $("h4").on("keydown", function (event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      $(this).click();
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    var links = document.querySelectorAll(".link-a");
    links.forEach(function(link) {
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
    });
  }, 100);
});

$(document).ready(function() {
 $("#text-p").attr('tabindex', '-1').attr('aria-hidden', 'true');
$(".page-h4").on('keydown', function(event) {
  if (event.key === "Tab" || event.keyCode === 9) {
    var currentH4 = $(this).closest('h4.page-h4');
    if (event.shiftKey) {
      var prevH4 = currentH4.prevAll('h4.page-h4').first();
      if (prevH4.length) {
        prevH4.get(0).focus(); 
        event.preventDefault(); 
      } 
    } else {
      $(this).nextAll('h4').first().find('.page-h4').focus();
    }
  }
});


  $(".page-h4").on('keydown', function(event) {
    if(event.key === "Enter" || event.keyCode === 13){   
      $(this).nextAll('div').first().find('#text-p').attr('aria-hidden', 'false').attr('tabindex', '0');
      $(this).nextAll('div').first().find('.link-a').attr('tabindex', '0').attr('aria-hidden', 'false');
      $(this).nextAll('div').first().find('#cud-p').attr('aria-hidden', 'false').attr('tabindex', '0');
}
});
});




let enterKeyPressedd = false;

$(document).ready(function () {
  let enterKeyPressedd = false;

  $("#end-h4-10").on("keydown", function (event) {
      if (event.key === "Enter" || event.keyCode === 13) {
        enterKeyPressedd = true;
          setTimeout(() => {
            enterKeyPressedd = false;
          }, 1000);
      }
  });

  const focusAboutLink = function (event) {
      if ((event.key === "Tab" || event.keyCode === 9) && !enterKeyPressedd && !event.shiftKey) {
          event.preventDefault();

          var customerNavLinks = $("a.CustomerNav__link");
          var aboutLink = customerNavLinks.filter(function () {
              return $(this).text().trim() === "About Us";
          });
          if (aboutLink.length > 0) {
              aboutLink.focus();
          }
      } 
  };

  $("#end-h4-10").on('keydown', focusAboutLink);
  $("#go-about").on('keydown', focusAboutLink);
});




$(document).ready(function() {
  $(document).on('keydown', function(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      var focusedElement = document.activeElement;
      if (focusedElement && focusedElement.classList.contains('CustomerNav__link') && focusedElement.textContent.trim() === "About Us") {
        focusedElement.click(); 
      }
    }
  });
});


// color swatchs backward tab navigation fixed 
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(function () {
      const swatchesHoverElements = document.querySelectorAll('.Product__swatches--hover');

      function isDesktop() {
          return window.innerWidth > 1024;
      }

      if (isDesktop()) {
          swatchesHoverElements.forEach(swatchesHover => {
              // Function to show buttons
              function showButtons() {
                  const buttons = swatchesHover.querySelectorAll('button:nth-child(n+7)');
                  buttons.forEach(button => {
                      button.style.display = 'block';
                  });
              }

              // Function to hide buttons
              function hideButtons(event) {
                  if (!event || !swatchesHover.contains(event.relatedTarget)) {
                      const buttons = swatchesHover.querySelectorAll('button:nth-child(n+7)');
                      buttons.forEach(button => {
                          button.style.display = 'none';
                      });
                  }
              }

              // Event listeners for focus
              swatchesHover.addEventListener('focus', showButtons, true);
              swatchesHover.addEventListener('focusin', showButtons);

              // Event listener for focus out
              swatchesHover.addEventListener('focusout', hideButtons);

              // Event listeners for mouse
              swatchesHover.addEventListener('mouseenter', showButtons);
              swatchesHover.addEventListener('mouseleave', hideButtons);
          });
      }
      const mediaTransparentElements = document.querySelectorAll('.motion-reduce');
      mediaTransparentElements.forEach(mediaTransparent => {
        mediaTransparent.addEventListener('keydown', (event) => {
            if (event.shiftKey && event.key === 'Tab') {
                const activeElement = document.activeElement;
                const currentGridItem = activeElement.closest('.grid__item');
                if (currentGridItem) {
                   
                    const productTiles = Array.from(document.querySelectorAll('.grid__item'));
                    const currentTileIndex = productTiles.indexOf(currentGridItem);
                    if (currentTileIndex > 0) {
                        const prevProductTile = productTiles[currentTileIndex - 1];
                        const prevSwatchButtons = prevProductTile.querySelectorAll('button:nth-child(n+7)');
                        prevSwatchButtons.forEach(button => {
                            button.style.display = 'block';
                        });
                        const visibleSwatchButtons = Array.from(prevSwatchButtons).filter(button => {
                            return button.offsetWidth > 0 && button.offsetHeight > 0;
                        });
                        if (visibleSwatchButtons.length > 0) {
                            event.preventDefault();
                            
                            visibleSwatchButtons[visibleSwatchButtons.length - 1].focus();
                        }
                    }
                }
            }
        });
    });
  }, 4000);
});



document.addEventListener('DOMContentLoaded', () => {
  const titleElement = document.querySelector('.promotion-title');
  if (titleElement) {
      const text = titleElement.textContent;
      const newText = text.replace('DAY', 'DAY<span class="line-break">');
      titleElement.innerHTML = newText + '</span>';
  }
});



document.addEventListener('DOMContentLoaded', () => {
  var customerNavLinks = $("a.CustomerNav__link");

  var aboutLink = customerNavLinks.filter(function() {
      return $(this).text().trim() === "About Us";
  });


  var footerMenuLinks = $("a:contains('About Us')");

  if (aboutLink.length) {
      aboutLink.on('keydown', function(event) {

          if (event.key === "Tab") {
              event.preventDefault();
              footerMenuLinks.focus();
          }
      });
  } 
});


$(document).ready(function() {

  if (window.location.pathname.includes('customer-assistance')) {
      var customerNavLink = $("a.CustomerNav__link");

      var aboutLinks = customerNavLink.filter(function() {
          return $(this).text().trim() === "About Us";
      });

      var cudLinks = customerNavLink.filter(function() {
          return $(this).text().trim() === "Cuddl Duds Policies";
      });

      $("a:contains('About Us')").on('keydown', function(event) {
          if (event.key === "Tab" || event.keyCode === 9) {
              if (event.shiftKey) {
                  aboutLinks.focus();
                  event.preventDefault(); 
              } 
          }
      });

      $(aboutLinks).on('keydown', function(event) {
          if (event.key === "Tab" || event.keyCode === 9) {
              if (event.shiftKey) {
                  cudLinks.focus();
              } 
          }
      });
  }
});

//Filtering - after removing fliters then focus to filters secion again
$(document).ready(function () {
  let focusAfterTab = false;

  let preventFocusTwice = false;

  const setFocusOnFilterByHeading = () => {
      if (!preventFocusTwice) {
          preventFocusTwice = true;
          $('#verticalTitle').focus();
          setTimeout(() => {
              preventFocusTwice = false;
          }, 3000); 
      }
  };

  const handleFilterRemove = (event) => {
      if (event.type === 'click' || (event.type === 'keydown' && (event.key === 'Enter' || event.keyCode === 13))) {
          focusAfterTab = true;
          setTimeout(setFocusOnFilterByHeading, 5000);
      }
  };

  const handleTabKey = (event) => {
      if (event.key === 'Tab' || event.keyCode === 9) {
          if (focusAfterTab) {
              event.preventDefault();
              focusAfterTab = false;
              setFocusOnFilterByHeading();
          }
      }
  };

  const observer = new MutationObserver(function () {
      $(".active-facets__button, .active-facets__button-remove").off('click keydown').on("click keydown", handleFilterRemove);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  $(".active-facets__button, .active-facets__button-remove").on("click keydown", handleFilterRemove);
  $(document).on('keydown', handleTabKey);
});

$(function () {
  $('.menu-item-has-children > a').focus(function () {
      $(this).siblings('.sub-menu').css('visibility', 'visible');
      $(this).siblings('.sub-menu').css('opacity', 1);
      //$(this).css({ "color": "#f97596", "border": "0.5px solid #0000FF", "font-weight": "500" });
      $(this).parent('.menu-item-has-children').find('.swiper-wrapper').addClass('actived-ul');
      // $('.actived-ul').find('.swiper-slide > a').focus(function () {
      //     //$(this).css({ "color": "#f97596", "border": "0.5px solid #0000FF" });
      // }).blur(function () {
      //     $(this).css({ "color": "", "border": "" });
      // });
}).blur(function () {
  $(this).css({ "color": "", "border": "", "font-weight": "" });
  $(this).parent('.menu-item-has-children').find('.swiper-wrapper').removeClass('actived-ul');
  // $(this).parent('.menu-item-has-children').find('.swiper-slide-active').addClass('actived-ul');
  $(this).parent('.menu-item-has-children').find('.sub-menu').addClass('current-submenu');
   //$('.current-submenu').css('visibility', 'hidden');
  // $('.current-submenu').css('opacity', 0);
 
});

$('.menu-item-has-no-children >a').focus(function () {
   $('.current-submenu').css('visibility', 'hidden');
   $('.current-submenu').css('opacity', 0);
});
});


// Do not sell your personal information page ADA Fixed 
$(document).ready(function() {
  
  if (window.location.pathname.includes('ccpa-opt-out')) {
    const pTags = document.querySelectorAll(".rte.scroll-trigger.animate--slide-in p");
    pTags.forEach(function(p) {
      p.setAttribute('tabindex', 0);
    });
  }
});

// sortby ADA fix
document.addEventListener('DOMContentLoaded', () => {
  const sortBySelect = document.getElementById('SortBy-g');
  const attachEventListeners = (selectElement) => {
    if(!selectElement) return;
    selectElement.addEventListener('keydown', (event) => {
      if (event.key === "Enter" || event.keyCode === 13) {
      }
    });
    selectElement.addEventListener('change', () => {        
        $(document).on("keydown", function (event) {
          if (event.key === "Tab" || event.keyCode === 9) {
              $(".facet-filters__label").attr('tabindex', 0).focus(); 
              $(document).off("keydown"); 
          }
      });
      
    });
  };
  attachEventListeners(sortBySelect);
  const observerrd = new MutationObserver(() => {
    const newSortBySelect = document.getElementById('SortBy-g');
      attachEventListeners(newSortBySelect);
  });
  observerrd.observe(document.body, { childList: true, subtree: true });
});

// color swatchs selecting ADA Fix on collection pages
$(document).ready(function () {
  const productTiles = document.querySelectorAll('.grid__item');
  const lastSelectedSwatches = new Map();

  productTiles.forEach(tile => {
    const swatchesColorElements = tile.querySelectorAll('.js-QuickAddProductSwatch');

    swatchesColorElements.forEach(swatchesColor => {
      swatchesColor.addEventListener('keydown', (event) => {
        if (event.keyCode === 13) {
          event.preventDefault();
          selectSwatch(swatchesColor, tile);
          announceChecked();
        }
        if (event.keyCode === 32 ) {

          event.preventDefault();
        }
      });

      swatchesColor.addEventListener('focus', () => {
        updateAriaLabel(swatchesColor, tile);
      });
      initializeSwatch(swatchesColor, tile);
    });  
  });

  function initializeSwatch(swatch, tile) {
    const defaultLabel = swatch.getAttribute('aria-label');
    swatch.setAttribute('data-default-label', defaultLabel);

    if (swatch.classList.contains('Product__swatch--active')) {
      swatch.setAttribute('aria-label', `${defaultLabel} checked`);
      swatch.setAttribute('aria-checked', 'true');
      lastSelectedSwatches.set(tile, swatch);
    }
  }

  function selectSwatch(swatch, tile) {
    const swatchesColorElements = tile.querySelectorAll('.js-QuickAddProductSwatch');
    
    swatchesColorElements.forEach(el => {
      el.classList.remove('selected', 'Product__swatch--active');
      el.setAttribute('aria-checked', 'false');
      el.setAttribute('aria-label', el.getAttribute('data-default-label'));
    });

    swatch.classList.add('selected', 'Product__swatch--active');
    swatch.setAttribute('aria-checked', 'true');
    lastSelectedSwatches.set(tile, swatch);
    updateAriaLabel(swatch, tile);
  }

  function updateAriaLabel(swatch, tile) {
    const defaultLabel = swatch.getAttribute('data-default-label');
    if (swatch === lastSelectedSwatches.get(tile) || swatch.classList.contains('Product__swatch--active')) {
      swatch.setAttribute('aria-label', `${defaultLabel} checked`);
    } else {
      swatch.setAttribute('aria-label', defaultLabel);
    }
  }

  function announceChecked() {
    const announcement = document.createElement('div');
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'assertive');
    announcement.textContent = 'checked';
    document.body.appendChild(announcement);

    setTimeout(() => {
      document.body.removeChild(announcement);
    }, 100);
  }
});


//HomePage collection banner images enter/space press navigation
var collectionImage = document.querySelectorAll('.HomeCollection');
collectionImage.forEach(homeCollectionDiv => {
  const anchorTags = homeCollectionDiv.querySelectorAll('a.home-collection-image-link');

  anchorTags.forEach(anchor => {
    const imgTags = anchor.querySelectorAll('img');

    imgTags.forEach(img => {
      img.addEventListener('keydown', function(event) {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          window.location.href = anchor.href;
        }
      });
    });
  });
});

//Store locator page last element current active footer link element tab navigation
 const belkLink = Array.from(document.querySelectorAll('.StoreLocator__link'))
 .find(link => link.textContent.trim() === 'Belk');

if (belkLink) {
  belkLink.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      e.preventDefault();
      const activeMenuItem = document.querySelector('.Footer__menu .list-menu__item--active');

      if (activeMenuItem) {
        activeMenuItem.focus(); 
      }
    }
  });
} 